<template>
    <div class="graph-box">
<!--        <div class="graph-box&#45;&#45;header">-->
<!--            <div class="graph-box&#45;&#45;header&#45;&#45;inner">-->
<!--                -->
<!--            </div>-->
<!--            <div class="graph-box&#45;&#45;header&#45;&#45;info">-->
<!--                <span class="graph-box&#45;&#45;header&#45;&#45;text&#45;&#45;2">ID: {{ deviceId }}</span>-->
<!--                <img src="images/icon-batery-full.svg" alt="Batery full" class="graph-box&#45;&#45;header&#45;&#45;icon">-->
<!--                <img src="images/icon-wifi-full.svg" alt="Wifi full" class="graph-box&#45;&#45;header&#45;&#45;icon">-->
<!--            </div>-->
<!--        </div>-->
        <div class="graph-box--info-graph">
            <div class="graph-box--info">
                <div class="graph-box--info--wrap">
                    <div class="graph-box--info--inner">
<!--                        <svg v-if="!name && [0,1].indexOf(type) != -1" class="graph-box&#45;&#45;header&#45;&#45;icon&#45;&#45;1 graph-box&#45;&#45;header&#45;&#45;icon" :fill="iconColorFill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16"><title>water</title><path d="M4.66,12.4a2.45,2.45,0,0,0,1.75-1.74A.8.8,0,0,1,8,10.8a3.59,3.59,0,0,1-1.14,2.11A3.3,3.3,0,0,1,4.8,14a.81.81,0,0,1-.14-1.6ZM0,10.93A5,5,0,0,0,5,16a5,5,0,0,0,5-5.07C10,7.33,6.12,5,5.81,1V.83a.81.81,0,1,0-1.62,0V1C3.87,5,0,7.33,0,10.93Z" transform="translate(0 0)"/></svg>-->
                        <span v-if="name" class="graph-box--header--text--1">{{ name }}</span>
                        <span v-if="!name" class="graph-box--header--text--1">{{ typeText }}</span>
                    </div>
                    <div  class="graph-box--info--inner">
                        <div class="graph-box--info--device">
                            <div v-if="type != 3">
                                <img src="images/vodomer-typ-1.png" alt="" width="58" class="graph-box--info--device--img">
                            </div>
                            <div class="graph-box--info--device--info">
                                <div v-if="type != 3" class="graph-box--info--device--text--1">B METERS</div>
                                <div class="graph-box--info--device--text--2">{{ deviceId }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="graph-box--info--inner">
                        <div v-if="[0,1].indexOf(type) != -1" class="graph-box--info--text--1">{{ $t('consumptionGraph.state') }}</div>
                        <div v-if="type == 2" class="graph-box--info--text--1">{{ $t('consumptionGraph.stateCalorimeter') }}</div>
                        <div v-if="usageData && [0,1].indexOf(type) != -1" class="graph-box--info--text--2">{{ toFixed(usageData.currentState,4) }} m<span class="graph-box--info--text--alt">3</span></div>
                        <div v-if="usageData && type == 2" class="graph-box--info--text--2">{{ toFixed(usageData.currentState * 1000,4) }} kWh</div>
                        <div v-if="usageData && type == 3" class="graph-box--info--text--2">{{ usageData.currentState }} jednotek</div>
                    </div>
                    <div v-if="type != 3" class="graph-box--info--inner">
                        <div class="graph-box--info--text--1">{{ $t('consumptionGraph.dayConsumption') }}</div>
                        <div v-if="usageData && [0,1].indexOf(type) != -1" class="graph-box--info--text--2">Ø {{ toFixed(usageData.dailyConsumption,3) }} m<span class="graph-box--info--text--alt">3</span></div>
                        <div v-if="usageData && type == 2" class="graph-box--info--text--2">Ø {{ toFixed(usageData.dailyConsumption* 1000,3) }} kWh</div>
                    </div>
                    <div v-if="type != 3" class="graph-box--info--inner">
                        <div class="graph-box--info--text--1">{{ $t('consumptionGraph.monthlyConsumption') }}</div>
                        <div v-if="usageData && [0,1].indexOf(type) != -1" class="graph-box--info--text--2">Ø {{ toFixed(usageData.monthlyConsumption,1) }} m<span class="graph-box--info--text--alt">3</span></div>
                        <div v-if="usageData && type == 2"  class="graph-box--info--text--2">Ø {{ toFixed(usageData.monthlyConsumption* 1000,1) }} kWh</div>
                    </div>
                </div>
                <!--            <div class="graph-box&#45;&#45;info&#45;&#45;select&#45;&#45;wrap">-->
                <!--                <div class="checkbox&#45;&#45;wrap">-->
                <!--                    <input v-model="showElevation" type="checkbox" :name="'compare' + this.id" :id="'compare' + this.id" class="checkbox&#45;&#45;input" hidden>-->
                <!--                    <label :for="'compare' + this.id" class="checkbox&#45;&#45;label">Zobrazit náměr</label>-->
                <!--                </div>-->
                <!--                <div class="checkbox&#45;&#45;wrap">-->
                <!--                    <input v-model="compare" type="checkbox" :name="'compare' + this.id" :id="'compare' + this.id" class="checkbox&#45;&#45;input" hidden>-->
                <!--                    <label :for="'compare' + this.id" class="checkbox&#45;&#45;label">Srovnání s:</label>-->
                <!--                </div>-->
                <!--                <div class="select&#45;&#45;wrap">-->
                <!--                    <select v-model="compareWith" :name="'compare-select' + this.id" :id="'compare-select' + this.id" class="select&#45;&#45;1 select">-->
                <!--                        <option value="720">Minulý měsíc</option>-->
                <!--                    </select>-->
                <!--                </div>-->
                <!--            </div>-->
            </div>
            <div class="graph-box--graph">
                <div class="graph-box--loading" v-if="usageData === null || usageData.measures === null">
                    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                </div>
                <div class="graph-box--graph--no-data" v-if="usageData && usageData.measures.length === 0">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 256" width="120"><path d="M170.3 122.1c-.6-1.5.1-3.1 1.5-3.7h.1l-3.5-8.5c-.6-1.5.1-3.1 1.6-3.7-.8-2.1-1.5-4.4-1.8-6.7-.2-1.1-.3-2.3-.4-3.4v-1.6c0-1.6.1-3.1.4-4.7l.3-1.5c.4-1.5.9-3 1.5-4.4l2.5-6c.2-.4.3-.9.5-1.3l1.7-5.3c.5-1.8.9-3.7 1-5.7l.1-3v-.3c-.2-.1-.5-.1-.7-.1-20.3-.6-31-8.7-35.2-12.7a2.66 2.66 0 0 0-3.7 0l-.2.2C118 72 91.6 68.9 82.8 67c-.7-.2-1.5 0-2.1.5.8 5 3.4 11.7 5.5 16.3 1 2.2 1.6 4.6 2 7 .1.4.1.9.1 1.3 0 .3.1.6.1.9v2.9c-.1 2.2-.5 4.5-1.1 6.6-.3 1.2-.7 2.3-1.1 3.4 1.5.6 2.2 2.3 1.6 3.7l-3.5 8.6h.1c1.4.6 2.1 2.3 1.6 3.7l-2.1 6.1c7.7 18 25.4 29.6 45 29.7 19-.1 36.3-11.1 44.3-28.3l-2.9-7.3z" fill="#f9d0b4"/><path d="M110.6 102.1c-2.8 0-5.1-2.3-5-5.1s2.3-5.1 5.1-5c2.8 0 5 2.3 5 5-.1 2.9-2.3 5.1-5.1 5.1zm37.3 0c-2.8 0-5.1-2.3-5.1-5 0-2.8 2.3-5.1 5-5.1 2.8 0 5.1 2.3 5.1 5 .1 2.8-2.2 5.1-5 5.1z" fill="#e9e9ea"/><path d="M175.7 62.1l.1-3c0-.7.1-1.3.1-2 .1-.9.1-1.7.3-2.6l.3-1.6.3-1.3c.9-2.9 2.7-4.8 6.1-4.7.3 0 .7.1 1 .2 1 .3 1.9.9 2.5 1.7.3.3.5.6.7.9l-10.4-24.8c-1.3-3.2.1-6.8 3.3-8.1.3-.1.7-.3 1-.3-8.8-5.1-19.6-5.1-28.3.2-5-8.5-14.1-13.7-24-13.7h-14.4c-13.6 0-26.6 5.5-36.1 15.2 1.1 1.2 1.7 2.6 1.7 4.2v.1c0 .8-.2 1.6-.5 2.4L68.9 49.8c.8-1.6 2.4-2.7 4.2-2.8 7.4-.3 7 8.9 7.2 16.8 0 .5 0 1.1.1 1.6 0 .7.1 1.4.2 2 .6-.5 1.4-.6 2.1-.5 8.9 1.9 35.2 5 53.1-17.5.9-1.1 2.6-1.3 3.7-.4l.2.2c4.1 4 14.8 12.1 35.2 12.7.3.1.5.2.8.2z" fill="#6d6c6b"/><path d="M169.9 83.8c2.3-5.3 5.5-13.3 5.7-18.4.4-8.3-.6-18.7 7.3-18.4 1.8.1 3.4 1.2 4.2 2.8l-10.5-24.9c-1.3-3.2.2-6.8 3.3-8.2 2.9-1.2 6.3-.1 7.8 2.6l13.8 23.9c4.6 8.9 5.5 19.2 2.6 28.7l-5.2 16.8c-.3 1.8-.4 3.6-.1 5.4l-28.8 12c-1.3-3.2-2.1-6.6-2.3-10.1-.3-4.2.5-8.4 2.2-12.2zm-41.4 74.1c-7.6 0-15.1-1.8-21.8-5.2v14.6l9.7 21.6c.8 1.7 2.4 2.8 4.3 2.8h16.4c1.8 0 3.4-1 4.2-2.6l10.5-21.7V152c-7.1 3.9-15.1 5.9-23.3 5.9zM86.1 83.8c-2.3-5.3-5.5-13.3-5.7-18.4-.3-8.3.6-18.7-7.3-18.4-1.8.1-3.4 1.2-4.2 2.8l10.5-24.9c1.3-3.2-.2-6.8-3.4-8.2a6.25 6.25 0 0 0-7.8 2.6L54.5 43.4C49.9 52.2 49 62.5 51.9 72l5.2 16.8c.3 1.8.4 3.6.1 5.4L86 106.1c1.3-3.2 2.1-6.6 2.3-10.1.3-4.2-.5-8.4-2.2-12.2z" fill="#f9d0b4"/><path d="M170 106.1l31.1-12.8c1.5-.6 3.1.1 3.7 1.6l3.5 8.6-36.4 15-3.5-8.6c-.6-1.5.1-3.2 1.6-3.8zm4.7 66.4l-11.3 33.9a4.15 4.15 0 0 1-5.5 2.3c-.7-.3-1.2-.7-1.7-1.3l-14.9-18.5 10.5-21.7 22.9 5.3zm-79.6 33.9a4.15 4.15 0 0 0 5.5 2.3c.7-.3 1.2-.7 1.7-1.3l14.4-18c-.1-.2-.3-.4-.4-.7l-9.7-21.6-22.9 5.3 11.4 34zM86 106.1L54.9 93.3c-1.5-.6-3.1.1-3.7 1.6l-3.5 8.6 36.4 15 3.5-8.6c.6-1.5-.1-3.2-1.6-3.8z" fill="#e9e9ea"/><g fill="#60bae2"><path d="M236.1 224.7c11.6-4.8 17.1-18 12.3-29.6l-36.3-90.2c-.6-1.5-2.3-2.2-3.7-1.6l-36.6 15.1c-1.5.6-2.2 2.3-1.6 3.7l36.3 90.2c4.8 11.6 18.1 17.1 29.6 12.4zm-216.2 0c-11.6-4.8-17.1-18-12.3-29.6l36.3-90.2c.6-1.5 2.3-2.2 3.7-1.6l36.6 15.1c1.5.6 2.2 2.3 1.6 3.7l-36.3 90.2c-4.8 11.6-18.1 17.1-29.6 12.4z"/><path d="M29.1 226.4l1-.1c-.4 0-.7.1-1 .1zm177.5-14l-14.8-36.7-17.1-3.1-11.3 33.9a4.15 4.15 0 0 1-5.5 2.3c-.7-.3-1.2-.7-1.7-1.3L141.3 189c-.8 1.6-2.4 2.6-4.2 2.6h-16.4c-1.6 0-3-.8-3.9-2.1l-14.4 18c-1.5 1.8-4.1 2.1-5.9.6-.6-.4-1-1-1.3-1.7l-11.3-33.9-19.9 3.6-14.6 36.3c-3.1 7.6-10.1 12.9-18.2 13.9l36.7-3.1c1.9-.2 3.7 1.3 3.8 3.2v23.1c0 2.2 1.8 4 4 4h107.1c2.2 0 4-1.8 4-4v-22.8c0-2 1.6-3.5 3.5-3.5h.3l31.9 2.7c-7.2-1.7-13.1-6.7-15.9-13.5z"/></g><path d="M38 71.7h-1.8v-1.8c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5v1.8h-1.8c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5h1.8v1.8c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5v-1.8H38c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5z" fill="#f75c64"/><g fill="#ffcd29"><path d="M201.5 2c0-.2-.1-.3-.1-.5-.1-.1-.1-.3-.2-.4s-.2-.3-.3-.4c-1-.9-2.5-.9-3.5 0-.1.1-.2.2-.3.4a.76.76 0 0 0-.2.4c-.1.2-.1.3-.1.5s-.1.3-.1.5a.9.9 0 0 0 .1.5c0 .2.1.3.1.5.1.2.1.3.2.4s.2.3.3.4c1 1 2.5 1 3.5 0 .1-.1.2-.2.3-.4a.76.76 0 0 0 .2-.4c.1-.1.1-.3.1-.5s0-.3.1-.5c-.1-.2-.1-.4-.1-.5z"/><use xlink:href="#B"/></g><use xlink:href="#B" x="194.6" y="-15.7" fill="#60bae2"/><path d="M226.2 21.1c-4.1-.8-7.2-4-8-8 0-.1-.1-.2-.2-.2s-.1.1-.2.2c-.8 4.1-4 7.2-8 8-.1 0-.2.1-.2.2s.1.1.2.2c4.1.8 7.2 4 8 8 0 .1.1.2.2.2s.1-.1.2-.2c.8-4.1 4-7.2 8-8 .1 0 .2-.1.2-.2-.1-.1-.1-.2-.2-.2z" fill="#6dcc6d"/><g fill="#231f20"><path d="M144.9 133.2a2.61 2.61 0 0 1-2.1-1.1c-5.1-7.5-15.3-9.5-22.8-4.4-1.7 1.2-3.3 2.7-4.4 4.4-.8 1.1-2.3 1.4-3.5.7s-1.4-2.3-.7-3.5c6.6-9.8 19.9-12.4 29.8-5.8 2.3 1.5 4.2 3.5 5.8 5.8.8 1.1.5 2.7-.7 3.5-.4.3-.9.4-1.4.4zm-34.3-28.6c-4.2 0-7.6-3.4-7.5-7.6 0-4.2 3.4-7.6 7.6-7.5 4.2 0 7.5 3.4 7.5 7.5-.1 4.2-3.4 7.6-7.6 7.6zm0-10.1c-.6 0-1.2.2-1.6.6-1.1.9-1.2 2.5-.3 3.6s2.5 1.2 3.6.3c.6-.5.9-1.2.9-2a2.57 2.57 0 0 0-2.1-2.5h-.5zm37.3 10.1c-4.2 0-7.6-3.4-7.6-7.5 0-4.2 3.4-7.6 7.5-7.6 4.2 0 7.6 3.4 7.6 7.5.1 4.2-3.3 7.6-7.5 7.6zm0-10.1c-.6 0-1.2.2-1.6.6-1.1.9-1.2 2.5-.4 3.6.5.6 1.2.9 2 .9 1.4 0 2.5-1.1 2.5-2.6a2.57 2.57 0 0 0-2.1-2.5h-.4zM95.4 70.8c-4.4 0-8.8-.4-13.1-1.3h-.1c-1.1.8-2.7.6-3.5-.5-.2-.3-.4-.7-.4-1v-.2c-.3-.8-.3-1.5-.4-2.3 0-.5 0-1.1-.1-1.6v-1.8c-.1-4.7-.2-10.1-2.2-11.9-.7-.6-1.5-.8-2.4-.7-.3 0-1.2.1-2.2 1.6-.7 1.2-2.3 1.5-3.4.8-1-.6-1.5-2-1-3.1L77.1 24a3.08 3.08 0 0 0 .3-1.3v-.2c0-.9-.4-1.8-1-2.5-.9-1-.9-2.5 0-3.5C86.3 6.3 100 .5 114.3.5h14.4c9.9.1 19.1 4.8 24.8 12.9 9.1-4.6 19.9-4.2 28.7 1 1.2.7 1.6 2.2.9 3.4-.3.6-.9 1-1.6 1.2-1.2.3-2.1 1.1-2.6 2.2a4.47 4.47 0 0 0 0 2.8l10.5 24.9c.5 1.3-.1 2.7-1.3 3.3-1.1.5-2.4.1-3.1-1-.1-.2-.3-.4-.5-.7-.3-.4-.8-.7-1.2-.9-.1 0-.3-.1-.5-.1-1.6-.1-2.8.4-3.6 2.9-.1.3-.2.7-.3 1.1-.1.5-.2.9-.2 1.4-.1.7-.2 1.5-.2 2.4 0 .6-.1 1.3-.1 1.9 0 1-.1 1.9-.1 2.9 0 .8-.4 1.5-1.1 2-.6.5-1.5.6-2.2.4h-.1c-20.7-.6-31.9-8.7-36.8-13.4-.1-.1-.1-.1-.2 0-13 16.2-30.2 19.7-42.5 19.7zm-12.5-6.3c.1 0 .2 0 .4.1 9.7 2 33.9 4.5 50.6-16.6 1.8-2.2 5-2.6 7.2-.8.1.1.3.2.4.4 3.4 3.3 13.1 10.9 31.7 11.9v-.4c0-.7.1-1.4.1-2.1l.3-2.8c.1-.7.2-1.3.3-1.8s.3-1 .4-1.5c1.6-5 4.9-6.3 7.8-6.4l-7.8-18.6a8.65 8.65 0 0 1 1.5-9.1c-7.2-2.7-15.3-2-21.9 2-1.2.7-2.7.3-3.4-.9-4.6-7.7-12.9-12.4-21.8-12.5h-14.4c-12.2 0-24 4.7-32.8 13.1.3.5.5 1.1.6 1.7.2.7.3 1.3.3 2v.3c0 1.2-.2 2.3-.7 3.4l-7.8 18.6c1.9 0 3.8.7 5.2 2.1 3.5 3.3 3.6 9.4 3.8 15.4v2.5z"/><path d="M128.5 160.4c-20.6 0-39.1-12.3-47.3-31.2-.2-.6-.3-1.2-.1-1.8l2.1-6.1v-.2c0-.2-.1-.3-.2-.4-1.3-.5-1.9-2-1.4-3.3l3.5-8.6v-.1c0-.1-.1-.3-.2-.3-1.3-.5-1.9-2-1.4-3.2.4-1 .8-2.1 1-3.2.6-2 .9-4 1.1-6.1.1-.9.1-1.8 0-2.6 0-.3 0-.5-.1-.8 0-.4-.1-.8-.1-1.3-.3-2.2-.9-4.3-1.8-6.4-1.9-4.8-4.6-11.7-5.4-16.9-.1-.9.2-1.8 1-2.4a5.06 5.06 0 0 1 4.1-.9c9.7 2 33.9 4.5 50.7-16.6 1.8-2.2 5-2.6 7.2-.8.1.1.3.2.4.4 3.5 3.4 13.7 11.4 33.5 12 .5 0 1 .1 1.4.3 1 .3 1.7 1.3 1.7 2.4v.2c0 1.1-.1 2.2-.1 3.2-.1 2.1-.5 4.2-1.1 6.2-.4 1.7-1 3.5-1.8 5.5-.2.5-.3.9-.5 1.4l-2.5 6.2c-.6 1.3-1 2.6-1.4 4l-.3 1.4c-.2 1.4-.4 2.8-.4 4.2V96c.1 1.1.2 2.1.4 3.1.4 2.1.9 4.2 1.7 6.2.5 1.3-.1 2.7-1.4 3.2-.2.1-.3.3-.2.5l3.5 8.6c.5 1.3-.1 2.7-1.4 3.3-.2 0-.3.2-.3.4v.2l2.6 7.4c.2.6.2 1.3-.1 1.9-8.2 17.9-26.4 29.5-46.4 29.6zm-42.2-32.3c10.6 23.3 38 33.7 61.4 23.2 9.8-4.4 17.8-12.2 22.5-21.9L168 123c-.7-1.9-.4-4 .9-5.5l-2.8-6.8c-.8-1.9-.4-4 .9-5.5-.6-1.8-1-3.6-1.3-5.4-.2-1.2-.4-2.4-.4-3.7 0-.6-.1-1.1-.1-1.7 0-1.7.1-3.4.4-5.1l.3-1.7c.4-1.7 1-3.3 1.6-4.9.9-2 1.7-4 2.4-5.9.2-.4.3-.9.5-1.3.7-1.9 1.2-3.6 1.6-5.1.5-1.7.8-3.4.9-5.1v-.9c-19.7-1-30.4-8.7-35.1-13.3h-.1s-.1 0-.1.1c-18 22.6-44.5 20.4-54.2 18.6 1.2 4.5 2.8 8.8 4.7 13.1 1.1 2.5 1.8 5.1 2.2 7.7.1.5.1 1 .2 1.5 0 .4.1.7.1 1 .1 1.1.1 2.1 0 3.2-.2 2.4-.6 4.8-1.2 7.1-.2.7-.4 1.3-.6 1.9a5.42 5.42 0 0 1 .9 5.6l-2.8 6.8c1.3 1.5 1.6 3.6.9 5.5l-1.5 4.9z"/><path d="M227.5 228.9c-10.2 0-19.4-6.2-23.3-15.6L168 123.1c-1.1-2.7.2-5.8 2.9-7l36.6-15.1c2.7-1.1 5.9.2 7 2.9l36.3 90.2c5.3 12.8-.9 27.5-13.7 32.8-3.1 1.3-6.3 2-9.6 2zm-18-123.3h-.1l-36.6 15.1c-.2.1-.3.3-.2.5l36.3 90.2c4.2 10.3 16 15.2 26.3 10.9 10.3-4.2 15.2-16 11-26.3l-36.3-90.2c-.1-.1-.2-.2-.4-.2z"/><path d="M171.9 120.9c-1 0-1.9-.6-2.3-1.6l-3.5-8.6c-1.1-2.7.2-5.9 2.9-7L200.2 91c2.7-1.1 5.9.2 7 2.9l3.5 8.6c.5 1.3-.1 2.7-1.4 3.3l-36.4 15c-.3 0-.6.1-1 .1zm-1-12.5c-.2.1-.3.3-.2.5l2.6 6.3 31.8-13.1-2.6-6.3c-.1-.2-.3-.3-.5-.2l-31.1 12.8z"/><path d="M170 108.6c-1 0-1.9-.6-2.3-1.6-1.4-3.5-2.2-7.1-2.4-10.8-.3-4.6.5-9.2 2.4-13.4 3.4-7.7 5.3-13.9 5.5-17.5 0-1.1.1-2.2.1-3.3.1-6 .3-12.2 3.8-15.4 1.4-1.3 3.3-2 5.2-2.1l-7.8-18.6c-1.9-4.5.2-9.6 4.7-11.4 4.1-1.7 8.8-.1 11 3.7L204 42.1s0 .1.1.1c4.9 9.4 5.9 20.4 2.7 30.6l-5.2 16.7c-.3 1.5-.3 3-.1 4.5.1 1.1-.5 2.2-1.5 2.6l-28.8 11.8c-.6.1-.9.2-1.2.2zm12.5-59.1c-.8-.1-1.6.2-2.1.7-1.9 1.8-2.1 7.2-2.2 11.9 0 1.2-.1 2.3-.1 3.4-.2 5.4-3.3 13.5-5.9 19.3-1.5 3.5-2.2 7.3-2 11 .1 2.3.6 4.7 1.3 6.9l24.6-10.1c-.1-1.5 0-2.9.4-4.4V88l5.2-16.8c2.8-8.9 1.9-18.5-2.4-26.7l-13.7-23.9c-1-1.8-3.3-2.4-5.1-1.4-1.6.9-2.3 2.9-1.6 4.7l10.5 24.9c.5 1.3-.1 2.7-1.3 3.3-1.1.5-2.4.1-3.1-1-1-1.6-1.9-1.6-2.2-1.6h-.3zm-12.6 34.3z"/><path d="M189.9 69.1h-.1c-1.4-.1-2.4-1.2-2.4-2.6.1-2.7 0-10.7-2.2-14.8-.6-1.2-.2-2.7 1.1-3.4 1.2-.6 2.7-.2 3.4 1.1 3.2 6.2 2.7 16.9 2.7 17.3 0 1.3-1.1 2.4-2.5 2.4zm-30.5 142.4c-2 0-3.9-.9-5.2-2.5l-14.9-18.5c-.6-.8-.7-1.8-.3-2.7l10.5-21.7c.5-1 1.7-1.6 2.8-1.3l22.9 5.3c1.3.3 2.2 1.7 1.9 3 0 .1 0 .2-.1.2l-11.3 33.9c0 .1 0 .1-.1.1-.9 2.2-2.9 3.8-5.2 4.1-.3.1-.6.1-1 .1zm-15.2-22.9l13.9 17.3c.6.7 1.7.9 2.4.3.2-.2.4-.4.5-.6l10.4-31.2-18.2-4.2-9 18.4zm-45.1 22.9c-.3 0-.7 0-1-.1-2.4-.3-4.4-1.9-5.2-4.1 0 0 0-.1-.1-.1l-11.3-33.9c-.4-1.3.3-2.7 1.6-3.2.1 0 .2 0 .2-.1l22.9-5.3c1.2-.3 2.4.3 2.8 1.4l9.7 21.6c0 .1.1.2.2.3.6.9.5 2.1-.1 2.9l-14.4 18c-1.4 1.7-3.3 2.6-5.3 2.6zm-1.6-6c.4.9 1.4 1.3 2.3.9.2-.1.5-.3.6-.5l13.4-16.7-8.6-19-18.2 4.2 10.5 31.1z"/><path d="M137.1 194.1h-16.4c-2.8 0-5.4-1.7-6.5-4.2l-9.7-21.6c-.1-.3-.2-.7-.2-1v-14.6c0-1.4 1.1-2.5 2.5-2.5.4 0 .8.1 1.1.3a46.35 46.35 0 0 0 20.7 4.9c7.7 0 15.3-1.9 22.1-5.6 1.2-.7 2.7-.2 3.4 1 .2.4.3.8.3 1.2v15.3c0 .4-.1.8-.2 1.1L143.5 190c-1.2 2.5-3.7 4.1-6.4 4.1zm-27.9-27.4l9.5 21.1c.4.8 1.1 1.3 2 1.3h16.4c.8 0 1.6-.5 2-1.2l10.3-21.2V156c-6.5 2.9-13.6 4.4-20.8 4.4a51.07 51.07 0 0 1-19.3-3.8l-.1 10.1zm-80.7 62.2c-13.9 0-25.1-11.3-25.1-25.2 0-3.3.6-6.5 1.9-9.5L41.5 104c1.1-2.7 4.3-4.1 7-2.9l36.6 15.1c2.7 1.1 4 4.3 2.9 7l-36.3 90.2c-3.8 9.3-13 15.5-23.2 15.5zm18-123.3c-.1 0-.3.1-.3.2L9.9 196.1c-4.3 10.3.5 22.1 10.8 26.4s22.1-.5 26.4-10.8c0-.1.1-.2.1-.3l36.3-90.2v-.3c0-.1-.1-.2-.2-.2l-36.6-15.1c-.1.1-.2 0-.2 0z"/><path d="M84.1 120.9c-.3 0-.6-.1-1-.2l-36.4-15c-1.3-.5-1.9-2-1.4-3.3l3.5-8.6c1.1-2.7 4.3-4 7-2.9L87 103.8c2.7 1.1 4 4.3 2.9 7l-3.5 8.6c-.4.9-1.3 1.5-2.3 1.5zM50.9 102l31.8 13.1 2.6-6.3c.1-.2 0-.4-.2-.5L53.9 95.6c-.2-.1-.4 0-.5.2l-2.5 6.2z"/><path d="M86 108.6c-.3 0-.6-.1-1-.2L56.3 96.6c-1-.4-1.7-1.5-1.5-2.6.2-1.5.2-3-.1-4.5l-5.2-16.7c-3.2-10.2-2.2-21.1 2.7-30.6 0 0 0-.1.1-.1l13.8-23.9C68.5 14 73.8 12.5 78 15c3.8 2.2 5.4 6.9 3.7 11l-7.8 18.6c1.9 0 3.8.7 5.2 2.1 3.5 3.3 3.6 9.4 3.8 15.4 0 1.1.1 2.2.1 3.3.2 3.6 2.1 9.8 5.5 17.5 1.8 4.2 2.7 8.8 2.4 13.4-.2 3.7-1.1 7.4-2.4 10.8-.5.9-1.4 1.5-2.5 1.5zm-26.1-16l24.6 10.1c.7-2.2 1.1-4.6 1.3-6.9.2-3.8-.4-7.6-2-11-2.6-5.8-5.7-13.9-5.9-19.3-.1-1.1-.1-2.3-.1-3.4-.1-4.7-.2-10.1-2.2-11.9-.7-.6-1.5-.8-2.4-.7-.3 0-1.2.1-2.2 1.6-.7 1.2-2.3 1.5-3.4.8-1-.6-1.5-2-1-3.1L77.1 24a3.75 3.75 0 0 0-2-4.9c-1.7-.7-3.8-.1-4.7 1.6L56.7 44.6c-4.3 8.3-5.1 17.9-2.4 26.7l5.2 16.8v.2c.4 1.4.5 2.9.4 4.3z"/><path d="M66.1 69.1c-1.3 0-2.4-1.1-2.5-2.4 0-.5-.5-11.2 2.7-17.3.6-1.2 2.1-1.7 3.4-1.1 1.2.6 1.7 2.1 1.1 3.4-2.1 4.1-2.3 12.1-2.2 14.8.1 1.4-1 2.5-2.4 2.6h-.1zm-37 159.8c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.4-2.5h.8c1.4-.1 2.6 1 2.7 2.3.1 1.4-.9 2.5-2.3 2.7l-1 .1c0-.1 0-.1-.1-.1z"/><path d="M182.8 256H75.7a6.49 6.49 0 0 1-6.5-6.5v-22.8c0-.6-.5-1-1-1h-.1l-36.7 3.1c-1.4.1-2.6-.9-2.7-2.3-.1-1.3.9-2.5 2.2-2.7 7.2-.9 13.5-5.6 16.2-12.3l14.6-36.2c.3-.8 1-1.4 1.9-1.5l19.8-3.6a2.52 2.52 0 0 1 2.8 1.7l11.3 33.8c.4.9 1.4 1.3 2.3.9.2-.1.5-.3.6-.5l14.4-18c.9-1.1 2.4-1.2 3.5-.4.2.2.4.4.5.6.4.6 1.1 1 1.8 1H137c.8 0 1.6-.5 2-1.2.6-1.2 2.1-1.8 3.3-1.2.3.2.6.4.9.7l14.9 18.5c.6.7 1.7.9 2.4.3.2-.2.4-.4.5-.6l11.3-33.8a2.52 2.52 0 0 1 2.8-1.7l17.1 3.1c.8.2 1.6.7 1.9 1.5l14.8 36.7c2.5 6.1 7.8 10.5 14.2 12a2.53 2.53 0 0 1 1.9 3c-.3 1.2-1.4 2-2.6 1.9l-31.9-2.7c-.6 0-1.1.4-1.1 1v22.9c-.1 3.4-3 6.3-6.6 6.3zM68.2 220.6a6.02 6.02 0 0 1 6 6v22.8a1.54 1.54 0 0 0 1.5 1.5h107.1a1.54 1.54 0 0 0 1.5-1.5v-22.8a6.02 6.02 0 0 1 6-6h.5l19.7 1.6c-2.7-2.5-4.9-5.6-6.3-9L190 177.8l-13.6-2.4-10.6 31.8c0 .1 0 .1-.1.1-1.4 3.4-5.3 5.1-8.7 3.7-1.1-.4-2-1.1-2.7-2l-13-16.2c-1.2.8-2.6 1.3-4.1 1.3h-16.4c-1.3 0-2.5-.3-3.6-1L104.3 209c-2.3 2.9-6.5 3.3-9.4 1-.9-.7-1.6-1.6-2-2.7 0 0 0-.1-.1-.1l-10.6-31.8-16.3 2.9-14.1 35c-1.5 3.5-3.7 6.7-6.6 9.3l22.5-1.9c.1 0 .3-.1.5-.1zm61.1-8.9c-.2 0-.3 0-.5-.1-.2 0-.3-.1-.5-.1-.2-.1-.3-.1-.4-.2s-.3-.2-.4-.3c-1-1-1-2.5 0-3.5.1-.1.2-.2.4-.3a.76.76 0 0 1 .4-.2c.2-.1.3-.1.5-.1 1.4-.3 2.7.6 2.9 2 .3 1.4-.6 2.7-2 2.9-.1-.1-.3-.1-.4-.1zm0 13.1c-.2 0-.3 0-.5-.1-.2 0-.3-.1-.5-.1-.2-.1-.3-.1-.4-.2s-.3-.2-.4-.3c-1-1-1-2.5 0-3.5.1-.1.2-.2.4-.3a.76.76 0 0 1 .4-.2 2.46 2.46 0 0 1 2.7.5c1 1 1 2.6 0 3.5a2.61 2.61 0 0 1-1.7.7zm0 13.1c-.2 0-.3 0-.5-.1-.2 0-.3-.1-.5-.1-.2-.1-.3-.1-.4-.2s-.3-.2-.4-.3c-.5-.5-.7-1.1-.7-1.8 0-.2 0-.3.1-.5 0-.2.1-.3.2-.5s.1-.3.2-.4c.2-.3.4-.5.7-.7a.76.76 0 0 1 .4-.2c.2-.1.3-.1.5-.1.8-.2 1.7.1 2.2.7a1.38 1.38 0 0 1 .3.4.76.76 0 0 1 .2.4.9.9 0 0 1 .1.5c0 .2.1.3.1.5 0 1.3-1.2 2.4-2.5 2.4z"/></g><defs ><path id="B" d="M25.8 96.6c0-.2-.1-.3-.1-.5-.1-.1-.1-.3-.2-.4s-.2-.3-.3-.4c-1-.9-2.5-.9-3.5 0-.1.1-.2.2-.3.4-.2.3-.3.6-.4.9s-.1.7 0 1c0 .2.1.3.1.5.1.2.1.3.2.4s.2.3.3.4c1 1 2.5 1 3.5 0 .1-.1.2-.2.3-.4a.76.76 0 0 0 .2-.4c.1-.1.1-.3.1-.5.2-.4.2-.7.1-1z"/></defs></svg>
                    </div>
                    <div class="no-data">Chybí data</div>
                </div>
                <div class="graph-box--graph--data" v-if="usageData && usageData.measures.length !== 0">
                    <bar-graph v-if="graphData && usageData.measures.length !== 0 && usageData.type === 'consumption'" :chart-data="graphData" :type="type"></bar-graph>
                    <line-graph v-if="graphData&& usageData.measures.length !== 0 && usageData.type === 'elevation'" :chart-data="graphData" :type="type"></line-graph>
                </div>
            </div>
        </div>
        <div class="graph-box--footer--wrap">
            <div class="graph-box--footer--inner">
                <div class="checkbox--wrap">
                    <input @change="updateData" v-model="showElevation" type="checkbox" :name="'elevation' + this.id" :id="'elevation' + this.id" class="checkbox--input" hidden>
                    <label :for="'elevation' + this.id" class="checkbox--label">Zobrazit náměr</label>
                </div>
            </div>
            <div class="graph-box--footer--inner">
                <div class="graph-box--export--wrap">
                    <a class="graph-box--button" @click.prevent="exportData" href="#">Exportovat do Excel</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import BarGraph from "@/components/Widgets/BarGraph";
import LineGraph from "@/components/Widgets/LineGraph";
import { exportMeasures } from "../../api/export";
import moment from "moment";
export default {
  name: "ConsuptionGraph",
  components: { BarGraph,LineGraph },
  props: {
      id: Number,
      deviceId: String,
      type: Number,
      name: null,
      // dayAverage: String,
      // monthlyAverage: String,

  },
  data: function() {
    return {
      datacollection: null,
      dayAverage: 0,
      monthlyAverage: 0,
      compare: false,
      showElevation: false,
      compareWith: 720,
    };
  },
  methods: {
    getColor() {
      switch (this.type) {
        case 1: return "#F9A51B4D";
        case 2: return "#F9A51B4D";
        default: return "rgba(8,62,137,0.3)";
      }
    },
    toFixed(value, places){
      return value.toFixed(places);
    },
    updateData(){
      this.$store.commit('device/removeMeasures', {deviceId: this.id});
      this.$store.dispatch('device/fetchDeviceData',{
        deviceId: this.id,
        dateFrom: this.$store.state.dashboardFilter.dateFrom,
        dateTo: this.$store.state.dashboardFilter.dateTo,
        type: this.showElevation? 'elevation' : 'consumption',
      });
    },
    exportData: async function(){
      this.$toasted.show('Připravuji export ke stažení.',{type: 'success'});
      const dateFrom = this.$store.state.dashboardFilter.dateFrom.format('HH:mm DD-MM-YYYY');
      const dateTo = this.$store.state.dashboardFilter.dateTo.format('HH:mm DD-MM-YYYY');
      const accessToken = this.$store.state.user.authTokens.accessToken;

      const response = await exportMeasures(accessToken, this.id, {dateFrom, dateTo});

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download','export.xlsx');
      document.body.appendChild(link);
      link.click();
    }
  },
  computed: {
    ...mapState("structure", ["currentDashboard"]),
    iconColorFill() {
      switch (this.type) {
        case 1: return '#F9A51B';
        case 2: return '#F9A51B';
        default: return '#083E89';
      }
    },
    typeText(){
      const textId = 'consumptionGraph.type.' + this.type;
      return this.$t(textId);
    },
    usageData(){
      return this.$store.getters['device/measures'](this.id);
    },
    graphData(){
      if(this.usageData){
        const dataset = {
            label: '',
            borderColor: this.getColor(),
            data: this.usageData.measures.map(({ value }) => {
              if(this.type === 2){
                return value * 1000
              }else{
                return value;
              }
            }),

          };

        if(this.usageData.type === 'consumption'){
          dataset.backgroundColor = this.getColor();
        }
        if(this.usageData.type === 'elevation'){
          dataset.backgroundColor = '#FFF';
          dataset.cubicInterpolationMode = 'monotone';
        }

        return {
          // labels: response.labels,
          labels: this.usageData.measures.map(({ date }) => date).map((date) => moment(date).format('DD.MM')),
          cornerRadius: 20,
          datasets: [dataset]
        }
      }

      return null;
    }
  },
  created() {
    this.updateData();
  },
};
</script>

<style scoped lang="less">
    .graph-box {
        border: 1px solid #CCCCCC7A;
        border-radius: 10px;
        padding: 32px 32px 16px 32px;
        width: 100%;
        display: flex;
        flex-direction: column;
        /*max-height: 426px;*/
        &--header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &--text {
                &--1 {
                    font-size: 1rem;
                    font-weight: 500;
                    color: #2a0f51;
                }
                &--2 {
                    font-size: 0.688rem;
                    font-weight: 400;
                    color: #b2b3b7;
                    text-transform: uppercase;
                }
            }
            &--info {
                display: flex;
                align-items: center;
            }
            &--icon {
                height: 16px;
                margin: 0 0 0 16px;
                &--1 {
                    margin: 0 8px 0 0;
                }
            }
            &--inner {
                display: flex;
                align-items: center;
            }
        }
        &--info-graph {
            display: flex;
            border-bottom: solid 1px #DFDFDF;
            padding-bottom: 20px;
        }
        &--info {
            flex: 0 0 240px;
            &--wrap {
            }
            &--inner {
                padding: 20px 0 0;
                &:first-child {
                    padding: 0;
                }
            }
            &--device {
                border-radius: 5px;
                display: inline-flex;
                align-items: center;
                min-height: 68px;
                min-width: 161px;
                background: #ffffff;
                box-shadow: 0 10px 15px #0000000F;
                &--img {

                }
                &--info {
                    margin-left: 8px;
                }
                &--text {
                    &--1 {
                        color: #011736;
                        font-size: 12px;
                        font-weight: 700;
                    }
                    &--2 {
                        color: #757575;
                        font-size: 12px;
                    }
                }
            }
            &--text {
                &--1 {
                    color: #979797;
                    font-size: 0.875rem;
                    font-weight: 400;
                }
                &--2 {
                    font-size: 1rem;
                    font-weight: 500;
                    color: #2A0F51;
                    padding-top: 2px;
                }
                &--alt {
                    font-size: 0.875rem;
                    font-weight: 700;
                    color: #2a0f51;
                    position: relative;
                    top: -8px;
                }
            }
            &--select {

            }
        }
        &--graph {
            flex: 1 1 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
            font-weight: 500;
            color: #2a0f51;
            position: relative;
            min-height: 235px;
            &--data {
                width: 100%;
            }
            &--no-data {
                width: auto;
            }
        }
        &--footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &--wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-direction: row-reverse;
                padding: 15px 0 0;
            }
            &--inner {
                position: relative;
            }
        }
        &--button {
            background: none;
            border: none;
            padding: 5px 15px;
            margin-left: -15px;
            outline: none;
            color: #323133;
            font-size: 12px;
            text-decoration: none;
        }
        &--loading {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    .checkbox--label {
        color: #757575;
        font-size: 12px;
    }
    .no-data {
        text-align: center;
        padding: 1px 0 0;
        text-transform: uppercase;
    }
    .lds-ring {
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;
        animation: lds-ring-scale 20s ease infinite;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 51px;
        height: 51px;
        margin: 3px;
        border: 3px solid #2a0f51;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #2a0f51 transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    @keyframes lds-ring-scale {
        0% {
            transform: scale(1.5) rotate(0deg);
        }
        100% {
            transform: scale(1.5) rotate(360deg);
        }
    }
</style>
